import React, { useState } from 'react'
import { Box, Button, TextField, Typography } from '@mui/material';
import Colors from '../Constant/Colors';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer/Footer';
import client from '../API/client'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const DesignerRegister = () => {
    const navigate = useNavigate();
    const [user,setUser]=useState({
        fullname:"",
        username:"",
        email:"",
        about:"",
        skills:"",
        portfolio:"",
        password:"",
        role:"designer",
        avatar:""
       });


const onsubmitRegister = async () =>{
      const {fullname,username,email,about,skills,portfolio,role,password} =user;
      const payload = {fullname,username,email,about,skills,portfolio,role,password};
      // console.log(user)
      const result = await client.post('/designer-signup',payload,{
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
      }).then(async (res)=>{
        const status = await res.status;
       if( status == 200 ){
        
        alert("Registered Sucessfully")
        navigate('/login')
       }
      }).catch(error => {
        // console.log(error.response.status)
       if(error.response.status === 400){
        toast.error('Please Enter all the details', {
          position: toast.POSITION.TOP_CENTER,
        });
       }
       if(error.response.status === 422){
        toast.warn('Email already exist', {
          position: toast.POSITION.TOP_CENTER,
        });
       }
      })
}


       const handleOnChange = (e) => {
        e.preventDefault();
        setUser((prev) => {
            return{
                ...prev,
                [e.target.name] : e.target.value
            }
        })
    }


  return (
    <>
    <div className="root" style={{display:"flex" ,justifyContent:"center",alignItems:"center",marginBottom:"60px"}} >
    <ToastContainer />
    <form className="form" style={{display: 'flex',flexDirection: 'column',alignItems: 'center',width: '40%',minWidth: 300,padding: "50px",borderRadius: "20px",boxShadow: "0.1rem 0.1rem  1rem 1rem rgba(201,201,201,0.57)",backgroundColor: Colors.white,marginTop:"45px"
    }}>
      <Typography variant='h7' >Hiring for project? <Link to="/register/recruiter-registration" style={{textDecoration:"none" ,color:Colors.btncolor}} >Signup as Recruiter</Link> </Typography>

      <h3 style={{margin:"30px"}}>SignUp form for Designer</h3>
      <TextField
        label="Username"
        name="username"
        value={user.username}
        variant="outlined"
        required
        style={{
          width: '100%',
          margin:"10px"
        }}
        onChange={handleOnChange}
      />
      <TextField
        label="Full Name"
        name="fullname"
        value={user.fullname}
        variant="outlined"
        required
        style={{
          width: '100%',
          margin:"10px"
        }}
        onChange={handleOnChange}
      />
      <TextField
        label="Email"
        name="email"
        value={user.email}
        variant="outlined"
        type="email"
        required
         style={{
          width: '100%',
          margin:"10px"
        }}
        onChange={handleOnChange}
      />
      <TextField
        label="Password"
        name="password"
        value={user.password}
        variant="outlined"
        type="password"
        required
         style={{
          width: '100%',
          margin:"10px"
        }}
        onChange={handleOnChange}
      />
      <TextField
        label="Skills"
        name="skills"
        value={user.skills}
        variant="outlined"
        placeholder='UI/UX, Artist'
        required
         style={{
          width: '100%',
          margin:"10px"
        }}
        onChange={handleOnChange}
      />
      <TextField
        label="Bio"
        name="about"
        value={user.about}
        variant="outlined"
        multiline
        rows={4}
        required
         style={{
          width: '100%',
          margin:"10px"
        }}
        onChange={handleOnChange}
      />
      <TextField
        label="Portfolio URL"
        placeholder='https://my-Portfolio.com'
        variant="outlined"
        type="url"
             style={{
          width: '100%',
          margin:"10px"
        }}
        name="portfolio"
        value={user.portfolio}
        onChange={handleOnChange}
      />

      <Button
        variant="contained"
        color="primary"
        sx={{ 
            width: "100%",
            margin: "20px",
            background: Colors.secondary,
            borderRadius: 30,
            color:'black',
            '&:hover':{
              backgroundColor: Colors.primary,
              color: 'white',
            }
          }}
          onClick={onsubmitRegister}
      >
        Register
      </Button>
      <Box m="10px" >  <Typography variant='h7' >Already have an account?  <Link to="/login" style={{textDecoration:"none",color:Colors.btncolor}} >Log In</Link> </Typography>  </Box>
    </form>
    </div>
    <Footer/>
    </>
  )
}
